import { Tooltip } from "@mui/material";
import { useLayoutEffect, useRef, useState } from "react";
import adminIcon from "../icons/Admin.svg";
import selectOrganizationIcon from "../icons/Change organisation.svg";
import signoutIcon from "../icons/Signout.svg";
import { userHasAccessToMultipleOrganizations, userIsAdmin } from "../users/UserService";
import useNavLinkListStyles from "./NavLinkList.styles";
import NavLinkListItem from "./NavLinkListItem";
import { NavLinkListProps } from "./NavLinkMainList";

export type NavLinkUtilityListProps = NavLinkListProps;

function NavLinkUtilityList(props: NavLinkUtilityListProps) {
    const classes = useNavLinkListStyles({ ...props });
    const selectedOrgName = props.userSession.selectedOrg?.name;
    const orgItemTitle = selectedOrgName ?? "Select organisation";

    const orgItemRef = useRef<HTMLDivElement>(null);
    const [isTruncated, setIsTruncated] = useState(false);

    useLayoutEffect(() => {
        const span = orgItemRef.current?.querySelector("span");
        if (!span) {
            setIsTruncated(false);
            return;
        }
        const check = () => setIsTruncated(span.scrollWidth > span.clientWidth);
        check();
        // Measuring and setting state synchronously inside the observation pass makes the browser report
        // "ResizeObserver loop completed with undelivered notifications", so defer the measurement a frame.
        let pendingCheck = 0;
        const observer = new ResizeObserver(() => {
            window.cancelAnimationFrame(pendingCheck);
            pendingCheck = window.requestAnimationFrame(check);
        });
        observer.observe(span);
        return () => {
            window.cancelAnimationFrame(pendingCheck);
            observer.disconnect();
        };
    }, [orgItemTitle, props.isMinimized]);

    const tooltipTitle = !selectedOrgName ? (
        ""
    ) : isTruncated ? (
        <>
            {selectedOrgName}
            <br />
            (Change organisation)
        </>
    ) : (
        "Change organisation"
    );

    return (
        <ul className={`${classes.navList} ${classes.bottomNavList}`}>
            {userIsAdmin(props.userSession.verifiedUser) && <NavLinkListItem title="Admin" linkTo="/admin" icon={adminIcon} isMinimized={props.isMinimized} />}
            {userHasAccessToMultipleOrganizations(props.userSession.verifiedUser) && (
                <Tooltip title={tooltipTitle} placement="right">
                    <div ref={orgItemRef} className={classes.truncatedItem}>
                        <NavLinkListItem title={orgItemTitle} linkTo="/select-organisation" icon={selectOrganizationIcon} isMinimized={props.isMinimized} />
                    </div>
                </Tooltip>
            )}
            <NavLinkListItem title="Log out" linkTo={"/sign-out"} icon={signoutIcon} isMinimized={props.isMinimized} isActive={() => false} />
        </ul>
    );
}

export default NavLinkUtilityList;
